import client from '@/api/client'
import currentOrderQuery from '@/api/gql/_shared/order/query/current-order.gql'
import currentStoreQuery from '@/api/gql/_shared/order/query/current-store.gql'
import promotionAdjustmentQuery from '@/api/gql/_shared/order/query/promotion-adjustment.gql'
import variantsByIdsQuery from '@/api/gql/_shared/order/query/variants-by-ids.gql'
import applyPromotionToCurrentOrderMutation from '@/api/gql/_shared/order/mutation/apply-promotion-to-current-order.gql'
import completeCurrentOrderMutation from '@/api/gql/_shared/order/mutation/complete-current-order.gql'
import removePromotionFromCurrentOrderMutation from '@/api/gql/_shared/order/mutation/remove-promotion-from-current-order.gql'

const resolveData = promise => promise.then(({ data }) => data)

export function fetchCurrentOrder() {
  return resolveData(client.query({ query: currentOrderQuery }))
}

export function fetchStore() {
  return resolveData(client.query({ query: currentStoreQuery }))
}

export function fetchCartItems(ids) {
  return resolveData(client.query({ query: variantsByIdsQuery, variables: { ids } })).then(
    data => data.variants
  )
}

export function applyPromotionToCurrentOrder(promoCode) {
  return resolveData(
    client.mutate({ mutation: applyPromotionToCurrentOrderMutation, variables: { promoCode } })
  )
}
export function removePromotionFromCurrentOrder(promoCode) {
  return resolveData(
    client.mutate({
      mutation: removePromotionFromCurrentOrderMutation,
      variables: { promoCode },
    })
  )
}
export function fetchAdjustmentFromCurrentOrder() {
  return resolveData(client.query({ query: promotionAdjustmentQuery }))
}

export function completeCurrentOrder() {
  return resolveData(client.mutate({ mutation: completeCurrentOrderMutation }))
}
